import { useEffect, useState } from 'react';

/** Browser online/offline. Defaults true when navigator missing (SSR/tests). */
export function useOnlineStatus({
  getOnline = () => (typeof navigator === 'undefined' ? true : navigator.onLine),
  subscribe = (onChange) => {
    if (typeof window === 'undefined') return () => {};
    const handle = () => onChange(navigator.onLine);
    window.addEventListener('online', handle);
    window.addEventListener('offline', handle);
    return () => {
      window.removeEventListener('online', handle);
      window.removeEventListener('offline', handle);
    };
  },
} = {}) {
  const [online, setOnline] = useState(() => getOnline());

  useEffect(() => {
    setOnline(getOnline());
    return subscribe(setOnline);
  }, [getOnline, subscribe]);

  return online;
}
